module.exports = __webpack_public_path__ + "static/img/school-11.b970d7d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school-11.png
// module id = cu1M
// module chunks = 0